/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';
// import { useSelector } from 'react-redux';
// material-ui
// import { useTheme } from '@mui/material/styles';
import { List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item }) => {
    const items = item?.children; //?.filter((menu) => permissions[menu?.id]);
    const renderedItems = items?.map((menu) => {
        switch (menu?.type) {
            case 'collapse':
                return <NavCollapse key={menu?.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu?.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu?.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });
    return items.length > 0 ? ( //items
        <>
            <List
                subheader={
                    item?.title && (
                        <Typography gutterBottom>
                            {item?.title}
                            {item?.caption && <Typography gutterBottom>{item?.caption}</Typography>}
                        </Typography>
                    )
                }
            >
                {renderedItems}
            </List>
        </>
    ) : (
        <></>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
